<template>
  <!-- Offcanvas Drawer -->
  <div
    id="sensorDetailDrawer"
    class="offcanvas offcanvas-end"
    :class="drawerClass"
    tabindex="-1"
  >
    <div
      class="offcanvas-header"
      :class="headerClass"
    >
      <h5 class="offcanvas-title">
        {{ setsensor?.sname }} 상세 정보
      </h5>

      <img
        v-if="isStrenge === true"
        class=""
        :src="strengthIcon"
        alt="통신"
        height="15"
      >

      <button
        type="button"
        class="btn-close"
        :class="closeButtonClass"
        aria-label="Close"
        @click="closeDrawer"
      />
    </div>

    <div class="offcanvas-body">
      <div v-if="setsensor && setdevice">
        <!-- 기본 정보 -->
        <div class="mb-3 card">
          <div class="card-header">
            <h6 class="mb-0">
              기본 정보
            </h6>
          </div>
          <div class="card-body">
            <div class="mb-2 row">
              <div class="col-5 fw-semibold">
                디바이스:
              </div>
              <div class="col-7">
                {{ setdevice.devicename }}
              </div>
            </div>
            <div class="mb-2 row">
              <div class="col-5 fw-semibold">
                디바이스 아이디:
              </div>
              <div class="col-7">
                {{ setdevice.deviceid }}
              </div>
            </div>
            <div class="mb-2 row">
              <div class="col-5 fw-semibold">
                센서명:
              </div>
              <div class="col-7">
                {{ setsensor.sname }}
              </div>
            </div>
            <div class="mb-2 row">
              <div class="col-5 fw-semibold">
                센서 키:
              </div>
              <div class="col-7">
                {{ setsensor.dfkey }}
              </div>
            </div>
            
            <div class="mb-2 row">
              <div class="col-5 fw-semibold">
                현재 값:
              </div>
              <div class="col-7">
                {{ setsensor.value }} {{ setsensor.unit }}
              </div>
            </div>
            <div class="mb-2 row">
              <div class="col-5 fw-semibold">
                수신 시간:
              </div>
              <div class="col-7">
                {{ formattedRecvdt }}
              </div>
            </div>
          </div>
        </div>

        <!-- 차트 영역 -->
        <div class="mb-3 card">
          <div class="card-header">
            <h6 class="mb-0">
              차트
            </h6>
          </div>
          <div class="card-body">
            <MonitorLineChart
              :setsensor="setsensor"
              :setdevice="setdevice"
            />
          </div>
        </div>

        <!-- 최근 데이터 영역 -->
        <div class="mb-3 card">
          <div class="card-header">
            <h6 class="mb-0">
              최근 수신 데이터
            </h6>
          </div>
          <div class="card-body">
            <CommGrid
              :rows="loadSensorDataResults"
              :columns="columnDefs"
              :is-check-box="false"
              :set-grid-height="250"
              :use-pagination="false"
            />
          </div>
        </div>

        <!-- 이벤트 목록 -->
        <div
          v-if="isSensorSetting"
          class="mb-3 card"
        >
          <div class="card-header">
            <h6 class="mb-0">
              이벤트
            </h6>
          </div>
          <div class="card-body">
            <div v-if="loadResults.length > 0">
              <div
                v-for="(event, index) in loadResults.slice(0, 5)"
                :key="index"
                class="mb-2 pb-2 border-bottom"
              >
                <div class="d-flex align-items-start justify-content-between">
                  <div>
                    <span class="bg-warning me-2 badge">{{ getEventTypeName(event.type) }}</span>
                    <span>{{ event.msg }}</span>
                  </div>
                  <small class="text-muted">{{ formatEventTime(event.startdt) }}</small>
                </div>
              </div>
            </div>
            <div
              v-else
              class="py-3 text-muted text-center"
            >
              최근 이벤트가 없습니다.
            </div>
          </div>
        </div>

        <!-- 알림 설정 정보 -->
        <div
          v-if="hasAlertConfig && isSensorSetting"
          class="mb-3 card"
        >
          <div class="card-header">
            <h6 class="mb-0">
              임계치 이탈 알림 설정
            </h6>
          </div>
          <div class="card-body">
            <div class="mb-2 row">
              <div class="col-5 fw-semibold">
                알림 활성화:
              </div>
              <div
                v-if="setGuageValue.alert == true"
                class="col-7"
              >
                <span class="bg-success badge">활성</span>
              </div>
              <div
                v-else
                class="col-7"
              >
                <span class="bg-secondary badge">비활성</span>
              </div>
            </div>
            <div class="mb-2 row">
              <div class="col-5 fw-semibold">
                임계값:
              </div>
              <div class="col-7">
                {{ setGuageValue.guage }}
              </div>
            </div>
          </div>
        </div>

        <!-- 통계 정보 -->
        <!-- <div class="mb-3 card">
          <div class="card-header">
            <h6 class="mb-0">24시간 통계</h6>
          </div>
          <div class="card-body">
            <div class="text-center row">
              <div class="col-4">
                <div class="text-muted fw-semibold">최소</div>
                <div class="fs-5">{{ stats.min }}</div>
              </div>
              <div class="col-4">
                <div class="text-muted fw-semibold">평균</div>
                <div class="fs-5">{{ stats.avg }}</div>
              </div>
              <div class="col-4">
                <div class="text-muted fw-semibold">최대</div>
                <div class="fs-5">{{ stats.max }}</div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <!-- Backdrop -->
  <div
    v-if="isOpen"
    class="offcanvas-backdrop fade show"
    style="z-index: 1040;"
    @click="closeDrawer"
  />
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import moment from 'moment'
import type { ColumnDefinition, Device, DeviceConfig, DeviceSensorConfig, EventListResult, SearchResult, SensorData } from '@/types/commontypes'
import MonitorLineChart from './MonitorLineChart.vue'
import { useThemeStore } from '../stores/themeStore'
import CommGrid from './CommGrid.vue'

import w00_white from "@/assets/images/w00_white.png"
import w01_white from "@/assets/images/w01_white.png"
import w02_white from "@/assets/images/w02_white.png"
import w03_white from "@/assets/images/w03_white.png"
import w04_white from "@/assets/images/w04_white.png"


import w00_dark from "@/assets/images/w00_dark.png"
import w01_dark from "@/assets/images/w01_dark.png"
import w02_dark from "@/assets/images/w02_dark.png"
import w03_dark from "@/assets/images/w03_dark.png"
import w04_dark from "@/assets/images/w04_dark.png"

const props = defineProps<{
  isOpen: boolean
  setsensor: SensorData;
  setdevice: Device;
}>();

const emit = defineEmits(['close'])

const themeStore = useThemeStore()

// 최근 24시간 날짜 설정
const deviceConfig = ref<DeviceConfig>({} as DeviceConfig);
const setGuageValue = ref<DeviceSensorConfig>({} as DeviceSensorConfig);

  
// 이벤트 데이터
const loadResults = ref<EventListResult[]>([])

const loadSensorDataResults = ref<SearchResult[]>([])
const columnDefs = ref<ColumnDefinition[]>([]);

const drawerClass = computed(() => {
  const classes = [themeStore.isDark ? 'bg-dark text-light' : 'bg-light']
  if (props.isOpen) {
    classes.push('show')
  }
  return classes.join(' ')
})

const headerClass = computed(() => {
  return themeStore.isDark ? 'border-secondary' : 'border-200'
})

const closeButtonClass = computed(() => {
  return themeStore.isDark ? 'btn-close-white' : ''
})

const formattedRecvdt = computed(() => {
  if (!props.setsensor?.recvdt) return '-'
  return moment(props.setsensor.recvdt).format('YYYY-MM-DD HH:mm:ss')
})

const hasAlertConfig = computed(() => {
  // 알림 설정이 있는지 확인
  return props.setdevice?.alertconfig ? true : false
})


const isStrenge = computed(() => {
    if(props.setsensor.strength === null || props.setsensor.strength === undefined || props.setsensor.strength < 0)
        return false

    return true
})

// strength 값에 따라 아이콘 이미지 선택
const strengthIcon = computed(() => {
    const strength = props.setsensor.strength

    if(strength === null || strength === undefined) {
        return ''
    }

    // 테마에 따라 다른 아이콘 세트 사용
    const iconMap: Record<number, string> = themeStore.isDark ? {
        0: w00_dark,
        1: w01_dark,
        2: w02_dark,
        3: w03_dark,
        4: w04_dark
    } : {
        0: w00_white,
        1: w01_white,
        2: w02_white,
        3: w03_white,
        4: w04_white
    }

    // strength 값이 0~4 범위를 벗어나면 기본값 사용
    return iconMap[strength] || (themeStore.isDark ? w00_dark : w00_white)
})

const closeDrawer = () => {
  emit('close')
}

/**
 * 온도, 습도, 근접센서 만 센서설정 가능
 */
const isSensorSetting = computed(() => {
    const settingList = ['5','6','19']
    const sindex = String(props.setsensor?.sindex)
    if(settingList.includes(sindex))
        return true
    else
        return false;
})

// 이벤트 타입 이름 변환
const getEventTypeName = (type: number) => {
  const typeMap: Record<number, string> = {
    0: '정보',
    1: '경고',
    2: '위험'
  }
  return typeMap[type] || '알림'
}

// 이벤트 시간 포맷팅
const formatEventTime = (dateStr: string) => {
  if (!dateStr) return '-'
  return moment(dateStr).format('MM-DD HH:mm')
}

// Drawer가 열릴 때 body에 스타일 추가 (스크롤 방지) 및 데이터 로드
watch(() => props.isOpen, (newVal) => {
  if (newVal) {
    document.body.style.overflow = 'hidden'
    // Drawer가 열릴 때 이벤트 데이터 로드
    if (props.setdevice && props.setsensor) {
      loadEventList()
      loadDeviceConfig()
      loadSDataList()
    }
  } else {
    document.body.style.overflow = ''
  }
})



const loadEventList = () => {
    const data = JSON.stringify({
        'operator': "getEventlist2",
        'deviceid' : props.setdevice?.deviceid,
    });

	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', function(){
		    const result : EventListResult[] = JSON.parse(xhr.responseText);
        const evtList: EventListResult[] = result.filter(item => {
            return item.dfkey === props.setsensor?.dfkey
        })

        // 현재 센서의 이벤트만 필터링
        const sensorEvents = evtList.filter(item =>
            item.deviceid === props.setdevice?.deviceid &&
            item.dfkey === props.setsensor?.dfkey
        )

        loadResults.value = [...sensorEvents];
    });
}


const loadDeviceConfig = () => {
	// 입력값을 변수에 담고 문자열 형태로 변환
  const data = JSON.stringify({ 'operator': "loadDeviceConfig", 'deviceid' : props.setdevice?.deviceid });
   
	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', () => {
		let result = JSON.parse(xhr.responseText);

    if(result) {
      if(result.err === 0) {
          deviceConfig.value = result.data;
          deviceConfig.value.configjson = JSON.parse(deviceConfig.value.config);

          // Initialize set_sensor if it doesn't exist
          if (!deviceConfig.value.configjson.set_sensor) {
            deviceConfig.value.configjson.set_sensor = {};
          }

          // props.setsensor가 존재하고 dfkey가 있을 때만 처리
          if (props.setsensor?.dfkey) {
            const dfkey = props.setsensor.dfkey;

            if(!deviceConfig.value.configjson.set_sensor[dfkey]) {
              deviceConfig.value.configjson.set_sensor[dfkey] = {alert:false, guage:0}
            }

            const alertconfig_temp = deviceConfig.value.alertconfig.replace(/[\r\n]+/g, '\\n');
            deviceConfig.value.alertconfigjson= JSON.parse(alertconfig_temp);

            const dConfig = deviceConfig.value.configjson;
            const sConfig = dConfig?.set_sensor?.[dfkey]

            if (sConfig) {
              setGuageValue.value.guage = sConfig.guage
              setGuageValue.value.alert = sConfig.alert
            }
          }
        } else {
          throw new Error("디바이스 설정 불러오기가 실패 했습니다.")
        }
      } else {
        throw new Error("디바이스 설정 불러오기가 실패 했습니다.")
    }
  });		
}


function loadSDataList() {
    const deviceobj = props.setdevice;
    
    getColumnInfo();
    LoadGridData(deviceobj);
}

function LoadGridData(deviceobj:Device | null) {
    if(!deviceobj) return;

   
    const strNow = moment().format('YYYY-MM-DD HH:mm:ss')
    const strPast24 = moment().subtract(24, 'hours').format('YYYY-MM-DD HH:mm:ss')

    const data = JSON.stringify({ 
        'operator': "getSDatalist", 
        'deviceid' : deviceobj.deviceid,
        'from' : strPast24,
        'to' : strNow 
    });
   
	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', function(){
		const result : SearchResult[] = JSON.parse(xhr.responseText);

    // 값이 없는 필드를 '-'로 변환
    const formattedResult = result.filter(row =>
      props.setsensor?.dfkey && row[props.setsensor.dfkey] !== undefined && row[props.setsensor.dfkey] !== null
    ).map(row => {
      const formattedRow: SearchResult = {regdt: row.regdt};
      if (props.setsensor?.dfkey) {
        formattedRow[props.setsensor.dfkey] = row[props.setsensor.dfkey]
      }
      return formattedRow
    })

    loadSensorDataResults.value = [...formattedResult];
  });
}

// 조회결과를 표시할 그리드의 컬럼정보를 구성함
function getColumnInfo() {
    const deviceobj = props.setdevice;
    if(!deviceobj)
        return;

    columnDefs.value = [];

    // 시간 컬럼: 헤더와 데이터 모두 가운데 정렬
    const adddef = {
        field: 'regdt',
        label: '시간',
        thClass: 'text-center',  // 헤더 가운데 정렬
        tdClass: 'text-center',  // 데이터 가운데 정렬
        width: '25%'
    };
    columnDefs.value.push(adddef);

    const svlistjson = JSON.parse(deviceobj.svlist);
    // console.log("getColumn svlistjson : ", svlistjson)
    for(const si in svlistjson) {
        const dfkey = svlistjson[si].dfkey;
        const sname = svlistjson[si].sname;
        if(props.setsensor?.dfkey !== dfkey)
          continue
        // 센서 데이터 컬럼: 헤더는 가운데, 데이터는 오른쪽 정렬 (숫자)
        const cDef: ColumnDefinition = {
            field: String(dfkey),
            label: String(sname),
            thClass: 'text-center',  // 헤더 가운데 정렬
            tdClass: 'text-center'    // 데이터 오른쪽 정렬 (숫자이므로)
        };
        columnDefs.value.push(cDef);
    }
}

</script>

<style scoped>
.offcanvas {
  width: 900px !important;
  max-width: 90vw;
  z-index: 1045;
}

.offcanvas.show {
  transform: none;
}

.offcanvas-backdrop {
  background-color: rgba(0, 0, 0, 0.5);
}

/* 모바일 대응 */
@media (max-width: 576px) {
  .offcanvas {
    width: 85vw !important;
  }
}
</style>
